import React, {useEffect} from 'react'
// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import GF from '../../assets/images/ourstory-bottom_left.jpg'
import MTA from '../../assets/images/ourstory-bottom_right.jpg'
import FancyBorder from '../../utils/FancyBorder'
import {Inner, Container, MainContent} from './styles'
import FancyImageHover from '../FancyImageHover'

interface IProps {
  translation: any
  langCode: string
}

const BottomSection: React.FC<IProps> = ({translation, langCode}) => {
  // useEffect(() => {}, [])
  return (
    <Container>
      <MainContent className="Warnock--Font a-center">
        <FancyImageHover href="/tickets">
          <img data-src={`${GF}`} className="Image--lazyLoad" data-sizes="auto" />
          <Inner className="left__inner" langCode={langCode}>
            <span className="">{translation['Discover the All-New Program']}</span>
            <div className="Garamond--Font" dangerouslySetInnerHTML={{__html: translation['T&T']}} />
          </Inner>
        </FancyImageHover>
      </MainContent>
      <MainContent className="Warnock--Font a-center">
        <FancyImageHover href="/artists">
          <img data-src={`${MTA}`} className="Image--lazyLoad" data-sizes="auto" />
          <Inner className="right__inner" langCode={langCode}>
            <article className="Garamond--Font right__inner__title" dangerouslySetInnerHTML={{__html: translation['Meet the Artists']}} />
          </Inner>
        </FancyImageHover>
      </MainContent>
    </Container>
  )
}

export default BottomSection
